<template>
  <a-modal
    :title="title"
    :width="640"
    :visible="visible"
    :confirmLoading="confirmLoading"
    :maskClosable="false"
    @cancel="handleCancel"
  >
    <a-spin :spinning="confirmLoading">
      <a-form-item
        v-show="false"
        label="id"
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
      >
        <a-input
          v-decorator="['id']"
          :disabled="editable || showable"
        />
      </a-form-item>
      <a-form :form="form">
        <a-form-item
          label="主键"
          :hidden="true"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            :disabled="showable"
            v-decorator="['id', {rules: [{required: false, message: '请输入id'}]}]" />
        </a-form-item>
        <a-form-item
          label="考勤小组名称"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            placeholder="请输入考勤小组名称"
            :disabled="showable"
            v-decorator="['name', {rules: [{required: true, message: '请输入考勤小组名称'}]}]" />
        </a-form-item>
<!--        label="考勤员id，关联用户表id"-->
        <a-form-item
          label="考勤员"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-select
            placeholder="请选择考勤员"
            :filterOption="filterOption"
            :disabled="showable"
            showSearch
            :options="attendanceList"
            v-decorator="['leaderId', {rules: [{required: true, message: '请选择考勤员'}]}]"/>

        </a-form-item>
      </a-form>
    </a-spin>
    <template slot="footer" >
      <div v-show="editable || addable">
        <a-button key="cancel" @click="handleCancel">取消</a-button>
        <a-button key="forward" :loading="confirmLoading" type="primary" @click="handleOk">保存</a-button>
      </div>
    </template>
  </a-modal>
</template>

<script>
import pick from 'lodash.pick'
import { FormMixin } from '@/mixins/FormMixin'
import { getObj, addObj, putObj } from '@/api/common/AttendGroup'
import { dropDownByCode } from '@/api/sys/user'

export default {
  name: 'AttendCompanyAddOrUpdate',
  mixins: [FormMixin],
  data () {
    return {
      confirmLoading: false,
      form: this.$form.createForm(this),
      showable: false,
      attendanceList: [],
      purchaserQuery: {
        roleCode: 'sx_attend_manager'
      }
    }
  },
  methods: {
    edit (id, type) {
      this.visible = true
      const { form: { setFieldsValue, resetFields } } = this
      dropDownByCode(this.purchaserQuery).then(res => {
        this.attendanceList = res.data
      })
      if (['edit', 'show'].includes(type)) {
        this.confirmLoading = true
        getObj(id).then(res => {
          const record = res.data
          this.confirmLoading = false
          this.$nextTick(() => {
            setFieldsValue(pick(record, ['id', 'name', 'leaderId', 'leaderIdName']))
          })
        })
      } else {
        resetFields()
      }
    },
    filterOption (input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    },
    handleOk () {
      this.form.validateFields(async (err, values) => {
        if (!err) {
          this.confirmLoading = true
          try {
            if (this.type === 'add') {
              await addObj(values)
            } else if (this.type === 'edit') {
              await putObj(values)
            }
            setTimeout(() => {
              this.confirmLoading = false
              this.$emit('ok')
              this.handleCancel()
            }, 1500)
          } catch (e) {
            this.confirmLoading = false
            this.$message.error(e.msg)
          }
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
